import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as constants from 'redux/constants/app.constants';
import {
  getMinimumPurchase, getAllSliders, getWhatsapp, getDiscount, getPopUpImage, getContact,
  getPdfTarifas, getEnvioGratis, getEnvios, getInitialData,
} from 'services/app.services';
import { categoryGetAll, categoryHomeGet } from './category.sagas';
import { productGetAllOffers, productGetMaxPrice, productGetOffers, productGetNewArrivals, productGetMostSelled } from './product.sagas';
import { userProfile } from './user.sagas';



export function* loadInitialData() {
  try {
    const data = yield call(getInitialData);
    yield all([
      call(safeCall, minimumPurchaseGet, data.minimumAmount.original),
      call(safeCall, envioGratisGet, data.envio_gratis.original),
      call(safeCall, whatsappGet, data.whatsapp.original),
      call(safeCall, popUpImageGet, data.popup.original),
      call(safeCall, tarifasPdfGet, data.tarifas.original),
      call(safeCall, contactGet, data.contact.original),
      call(safeCall, enviosGet, data.envios.original),
      call(safeCall, slidersGetAll, data.sliders.original),
      call(safeCall, categoryGetAll, data.categories.original),
      // call(safeCall, productGetAllOffers, data.getAllOffers.original),
      call(safeCall, userProfile, data.profile.original),
      call(safeCall, productGetMaxPrice, data.maxPrice.original),
      call(safeCall, categoryHomeGet, data.categoryHome.original),
      // call(safeCall, productGetOffers, data.offers.original),
      // call(safeCall, productGetNewArrivals, data.newArrivals.original),
      // call(safeCall, productGetMostSelled, data.mostSelled.original),
      call(safeCall, discountGet, data.discounts.original),
      
      call(safeCall, dataAnalyticsGet, data.dataAnalytics.original),
      call(safeCall, maintenanceGet, data.web_maintenance.original),
    ]);
  } catch (error) {
    console.log("error:" ,error);
    const errorMessage = `¡Lo sentimos! 
    Estamos trabajando en mejorar nuestra página web y necesitamos realizar algunas actualizaciones. Intentá actualizar la página web en este momento y sino funciona volvé a intentar en unos minutos.
    Gracias por tu paciencia y comprensión.`;
    yield put({type: constants.APP_INITIALIZE_FAILED, data : errorMessage});
  }
}

export function* safeCall(fn, ...args) {
  try {
    yield call(fn, ...args);
  } catch (error) {
    console.error(`Error en ${fn.name}:`, error);
  }
}

export function* maintenanceGet(data) {
  try {
    yield put({ type: constants.APP_MAINTENANCE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.APP_MAINTENANCE_FAILED, error });
  }
}

export function* dataAnalyticsGet(data ) {
  try {
    const dataAnalytics = data;
    yield put({ type: constants.APP_DATA_ANALYTICS_SUCCEEDED, data : dataAnalytics });
  } catch (error) {
    yield put({ type: constants.APP_DATA_ANALYTICS_FAILED, error });
  }
}

export function* minimumPurchaseGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const minimumPurchase = !isReduxAction && data ? data : yield call(getMinimumPurchase);
    yield put({ type: constants.APP_MINIMUM_PURCHASE_SUCCEEDED, data: minimumPurchase });
  } catch (error) {
    yield put({ type: constants.APP_MINIMUM_PURCHASE_FAILED, error });
  }
}

export function* envioGratisGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const categories = !isReduxAction && data ? data : yield call(getEnvioGratis);
    yield put({ type: constants.APP_ENVIO_GRATIS_SUCCEEDED, data: categories });
  } catch (error) {
    yield put({ type: constants.APP_ENVIO_GRATIS_FAILED, error });
  }
}

export function* discountGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const discounts = !isReduxAction && data ? data : yield call(getDiscount);
    yield put({ type: constants.APP_DISCOUNT_SUCCEEDED, data : discounts });
  } catch (error) {
    yield put({ type: constants.APP_DISCOUNT_FAILED, error });
  }
}

export function* slidersGetAll(data = null) {
  try {
    const isReduxAction = data && data.type;
    const sliders = !isReduxAction && data ? data : yield call(getAllSliders);
    yield put({ type: constants.APP_SLIDERS_GET_ALL_SUCCEEDED, data: sliders });
  } catch (error) {
    yield put({ type: constants.APP_SLIDERS_GET_ALL_FAILED, error });
  }
}

export function* whatsappGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const whatsapp = !isReduxAction && data ? data : yield call(getWhatsapp);
    yield put({ type: constants.APP_WHATSAPP_SUCCEEDED, data: whatsapp });
  } catch (error) {
    yield put({ type: constants.APP_WHATSAPP_FAILED, error });
  }
}

export function* popUpImageGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const popup = !isReduxAction && data ? data : yield call(getPopUpImage);
    yield put({ type: constants.APP_IMAGE_POPUP_SUCCEEDED, data: popup });
  } catch (error) {
    yield put({ type: constants.APP_IMAGE_POPUP_FAILED, error });
  }
}

export function* tarifasPdfGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const tarifas = !isReduxAction && data ? data : yield call(getPdfTarifas);
    yield put({ type: constants.APP_TARIFAS_SUCCEEDED, data: tarifas });
  } catch (error) {
    yield put({ type: constants.APP_TARIFAS_FAILED, error });
  }
}

export function* contactGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const contact = !isReduxAction && data ? data : yield call(getContact);
    yield put({ type: constants.APP_CONTACT_SUCCEEDED, data: contact });
  } catch (error) {
    yield put({ type: constants.APP_CONTACT_FAILED, error });
  }
}

export function* enviosGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const envios = !isReduxAction && data ? data : yield call(getEnvios);
    yield put({ type: constants.APP_ENVIOS_SUCCEEDED, data: envios });
  } catch (error) {
    yield put({ type: constants.APP_ENVIOS_FAILED, error });
  }
}

export function* watchApp() {
  yield all([
    takeLatest(constants.APP_INITIALIZE_REQUESTED, loadInitialData),
  ]);
}
